import { render, staticRenderFns } from "./appRole.vue?vue&type=template&id=3faed2b5&scoped=true&"
import script from "./appRole.vue?vue&type=script&lang=js&"
export * from "./appRole.vue?vue&type=script&lang=js&"
import style0 from "./appRole.vue?vue&type=style&index=0&id=3faed2b5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3faed2b5",
  null
  
)

export default component.exports